// extracted by mini-css-extract-plugin
export default {"modal":"DrillDownModal_modal__2Ibxf","tabs":"DrillDownModal_tabs__8nB6a","tabActions":"DrillDownModal_tabActions__uwako"};